// Shared normalization for attendance mark photos: the backend stores either a URL,
// a data URI, or a raw base64 segment in the same field.

export interface NormalizedMarkPhoto {
  photoUrl: string | null;
  photoBase64: string | null;
}

export function normalizeMarkPhoto(rawPhoto: string | null | undefined): NormalizedMarkPhoto {
  let photoBase64: string | null = null;
  let photoUrl: string | null = null;
  if (rawPhoto) {
    const trimmed = rawPhoto.trim();
    if (/^https?:\/\//i.test(trimmed)) {
      photoUrl = trimmed;
    } else if (/^data:image\//i.test(trimmed)) {
      // Strip data URI prefix to keep only raw base64 for uniform handling
      const commaIdx = trimmed.indexOf(',');
      if (commaIdx > -1) {
        photoBase64 = trimmed.slice(commaIdx + 1);
      } else {
        photoBase64 = trimmed; // fallback
      }
    } else {
      // Assume pure base64 segment
      photoBase64 = trimmed;
    }
  }
  return { photoUrl, photoBase64 };
}
